import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";

import back from "../../back.png";
import ClientReview from "../home/ClientReview";
import InvoiceForm from "./InvoiceForm";
import InputDate from "../../helpers/InputDate";
 


function CalculateReview(props)
{
    const [tab, setTab] = useState(null); 


 

      const [view, setView] = useState ( {view:"list", id: -1}  );

      const onBack = (e) => {
                setView({view:"list", id: -1}  );
      }

      const onSuccess = (e) => {
                setView({view:"list", id: -1}  );
                getRozDet();
      }

      const changeView = (e ) => {
                    var v = e.target.getAttribute('v');
                    var id = e.target.getAttribute('id');

                    setView({...view, ["v"]:v, ["id"]:id });
      }


      const editDate = (e) => {

        var id = e.target.getAttribute('id');      

        setView({...view, ["v"]:"change_date", ["id"]:id  });
      }


    const valChangeListener = (filedName, val, correct, msg) => {        
        
        
        
               
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2 && tabCheck[1] == "sugerowana") //pozycje..
                {
                    var inx = parseInt( tabCheck[0]);
                    var doRoz = JSON.parse( JSON.stringify( tab.doroz)) ;
                    
                   

                    if(val >  tab.doroz[inx].pozostalo ) 
                    {
                        val =  tab.doroz[inx].pozostalo ;
                    }

                    if(val > tab.pozostalo) val = tab.pozostalo;

                    



                    doRoz[ inx ]["sugerowana"] = val;

                        /*
                        var sumSugerowane = 0.0;

                        for(var k=0; k < tab.doroz.length; k++)
                        {
                                sumSugerowane = parseFloat(sumSugerowane) + parseFloat( tab.doroz[k].sugerowana);
                        }
                        */
    

                    setTab({...tab, ["doroz"]: doRoz  });
                    return;
                }
        
            
             //   tmpRow[filedName] = val;
              //  tmpRow[filedName+"_valid"] = correct;             
               // setRow(  JSON.parse(JSON.stringify(tmpRow)) );                             
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                        
            }   


    const listenerDate =  (filedName, val, correct, msg) => {


            for(var kk=0; kk < tab.roz.length; kk++)
            {
                if(tab.roz[kk].id == view.id) 
                {
                    tab.roz[kk].created_at = val;
                    break;
                }
            }

            setTab(JSON.parse(JSON.stringify(tab)) );
    }


    const getRozDet = () => {
                    
            
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_calc,calculate_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setTab(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
    }


    const assignCalc = (e) => {

         var inx = e.target.getAttribute('atr-inx');

        // alert( tab.doroz[inx].pozostalo );

        // tab.doroz[inx].pozostalo

        // item.pozostalo} // ile max... z tej pozycji

        //if(tab.doroz[inx].sugerowana  == '.') return;


           var val =  tab.doroz[inx].pozostalo;
           if(val > tab.pozostalo) val = tab.pozostalo;

      
                    
          var doRoz = JSON.parse( JSON.stringify( tab.doroz)) ;
          doRoz[ inx ]["sugerowana"] = val;

          tab["doroz"] = doRoz;
          //setTab({...tab, ["doroz"]: doRoz  });

          saveCalcV2(tab, inx);
      
          return;


    }


 const saveCalcV2 = (tabX, inx) => {

        

        // alert(tab.doroz[inx].sugerowana + ", " + tab.doroz[inx].opis + ", "+ tab.doroz[inx].id );

        if(tabX.doroz[inx].sugerowana  == '.') return;


                                        props.mainView.showProgress();


                                        var req = {
                                            id: tabX.id,
                                            fak_saldo_id: tabX.doroz[inx].id ,
                                            kwota: tabX.doroz[inx].sugerowana ,
                                        };

                                        fetch( Config.url + '/rest_v1_calc,calculate_calc', {
                                            method: 'POST', 
                                            body: JSON.stringify(  req ), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                        // props.mainView.showDialog( "Sukces", "Pozycja została przypisana" , "ok" , null);  
                                                         getRozDet();                                                                          
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });




    }

    const saveCalc = (e) => {

         var inx = e.target.getAttribute('atr-inx');

        // alert(tab.doroz[inx].sugerowana + ", " + tab.doroz[inx].opis + ", "+ tab.doroz[inx].id );

        if(tab.doroz[inx].sugerowana  == '.') return;


                                        props.mainView.showProgress();


                                        var req = {
                                            id: tab.id,
                                            fak_saldo_id: tab.doroz[inx].id ,
                                            kwota: tab.doroz[inx].sugerowana ,
                                        };

                                        fetch( Config.url + '/rest_v1_calc,calculate_calc', {
                                            method: 'POST', 
                                            body: JSON.stringify(  req ), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Pozycja została przypisana" , "ok" , null);  
                                                         getRozDet();                                                                          
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });




    }


    const updateDate = (e) => {


            var actValue = "";

            for(var kk=0; kk < tab.roz.length; kk++)
            {
                if(tab.roz[kk].id == view.id) 
                {
                    actValue = tab.roz[kk].created_at;
                    break;
                }
            }

                                props.mainView.showProgress();


                                        var req = {
                                            id: view.id,                                      
                                            created_at: actValue,                                      
                                        };

                                        fetch( Config.url + '/rest_v1_calc,calculate_up_date', {
                                            method: 'POST', 
                                            body: JSON.stringify(  req ), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Data została zmieniona" , "ok" , null);  
                                                         getRozDet();   
                                                         setView({...view, ["v"]:'list', ["id"]:'-1' });                                                                       
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });

                           
    }



    const goRemove = (e) => {

        var id = e.target.getAttribute('atr-id');
        var title = e.target.getAttribute('atr-title');

           props.mainView.showDialog( "Potwierdź", "Na pewno chcesz odpiąć przypisane rozliczenie (" + title + ") ? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,calculate_remove', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: id }), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem" , "ok" , null);  
                                                         getRozDet();                                                                          
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                       
    }



    const addTrash = (e) => {

         var id = e.target.getAttribute('atr-id');
         var poz = null;

         for(var kx=0; kx <  tab.roz.length; kx++) 
         {
            if(tab.roz[kx].id == id ) {
                poz = tab.roz[kx];
                break;
            }
         }

         if(poz == null) return;

         //console.log("POZ",poz);

         var uq =  tab.id+"_" + poz.id;

         //sprawczy czy jest w koszyku...
         var isExist = false;

         for(var kx=0; kx < props.mainView.vars.trash.length; kx++)
         {
            if( props.mainView.vars.trash[kx].uq == uq ) { isExist = true; break; }
         }

         if(isExist)
         {
                poz.blokada = 1;//zapisz w referencji..
                setTab( JSON.parse(JSON.stringify(tab)) ); //zaktualizuj widok..

                props.mainView.showDialog( "Potwierdź", "Ta pozycja jest już w koszyku!" , "ok" ,null);
                return;
         }



        props.mainView.showDialog( "Potwierdź", "Na pewno dodać do koszyka [odsetki: " + poz.ods.kwota_odsetek + " ] ? Możliwość edycji tego rozliczenia zostanie chwilowo zablokowana." , "yesno" ,  (res) => { 

             var trashItem = {
                uq: tab.id+"_" + poz.id,
                fak_saldo_id: tab.id,
                kwota: tab.kwota,
                opis: tab.opis,
                klient: tab.klient,
                roz: poz,
             }

             props.mainView.addToTrash(  JSON.parse(JSON.stringify(trashItem)) );

             poz.blokada = 1;//zapisz w referencji..
             setTab( JSON.parse(JSON.stringify(tab)) ); //zaktualizuj widok..


        } )

    }




            const keyListener = (e) => {


                
                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockd", e.target.nodeName, code );

                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                                                    
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        props.onBack();                               
                                } else 
                                {
                                    props.keyListener(e);
                                }
                              
            }


            useEffect(() => {                                                     

                        if(tab == null) getRozDet();

                        if(Config.env == "dev") console.log("CalculateReview.js, listener on");
                        window.onkeydown = keyListener;

                        return () => {          
                            if(Config.env == "dev") console.log("CalculateReview.js, listener off");      
                            window.onkeydown =  props.keyListener;
                        };

            });
        

    if(view.v == "client")
    {                                 
             return <ClientReview  userData={props.userData} mainView={props.mainView}  keyListener={keyListener}  onBack={onBack}  onSuccess={onSuccess}   id={tab.klient.id} />
    }


    if(view.v == "invoice")
    {
         return <InvoiceForm  userData={props.userData} mainView={props.mainView}  keyListener={keyListener} fak_kontrahenci_id={props.fak_kontrahenci_id} onBack={onBack}  onSuccess={onSuccess}   id={view.id} /> 
    }


    var dialog = null;
    if(view.v == "change_date")
    {
            var actValue = "";

            for(var kk=0; kk < tab.roz.length; kk++)
            {
                if(tab.roz[kk].id == view.id) 
                {
                    actValue = tab.roz[kk].created_at.substring(0,10);
                    break;
                }
            }

           

            dialog =  <div className="dlg_window shadowx " >

                                <div className="dlg_title" >Zmiana daty płatności</div>
                                <div className="dlg_msg" >

                        
                                <InputDate   userData={props.userData} value={actValue}   valChange={listenerDate} goNext={null} name="data" placeholder={"Data: "}  className=' w250 '  />
                                                
                                  
                                </div>
                                        <div className="dlg_btn">
                                            <div className="btn" onClick={changeView} v="list" id="-1" >zamknij</div>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <div className="btn" atr-type="ok" onClick={updateDate}>gotowe</div>
                                </div>
                </div>
    }
            

    if(tab == null)
    {        
        return <div>
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                    ...
        </div>
    }
    

    




   var cssX = "";
   if(tab.pozostalo == 0) cssX = " approved ";



   var sumSugerowane = 0.0;

   for(var k=0; k < tab.doroz.length; k++)
   {
        sumSugerowane = parseFloat(sumSugerowane) + parseFloat( tab.doroz[k].sugerowana);
   }

   var pozostalo =  parseFloat( tab.pozostalo) - parseFloat(sumSugerowane);
   pozostalo = parseFloat(pozostalo).toFixed(2);



   var sumKwPrzypisane = 0.0;
 
   for(var k=0; k< tab.roz.length; k++)
   {
        sumKwPrzypisane = parseFloat( tab.roz[k].kwota ) + parseFloat(sumKwPrzypisane);
   }



   var sumDoWyk = 0.0;
   var sumSugerowana = 0.0;

    for(var k=0; k< tab.doroz.length; k++)
   {
        sumDoWyk        = parseFloat( tab.doroz[k].pozostalo ) + parseFloat(sumDoWyk);
        sumSugerowana   = parseFloat( tab.doroz[k].sugerowana ) + parseFloat(sumSugerowana);
   }


    return <div className="bg_center">

           <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

           <div className="app_header"> 
            {tab.klient.nazwa}
             {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
            }
            &nbsp; &nbsp; 
            {tab.opis}, kwota: {tab.kwota}</div>
           <div className={"client_info " + cssX}>            
                 <div>Operacja / wpis z dnia: <b>{tab.data_operacji}</b>, kwota: <b> <FormatDecimal value={tab.kwota} /> </b>, <span className="txtAttation"> pozostało do rozliczenia: <b> <FormatDecimal value={pozostalo} /> </b>   </span>  </div>
           </div>





           <div className="form_tab_title">Powiązane rozliczenia ({tab.roz.length}):</div>

           
              

           <table className="table"  >
                  <thead>
                       <tr className="header">                                                                                               
                              <td className="td_left">LP</td>                           
                              <td>Data</td>                                                                                                                                    
                              <td>Opis</td>                          
                              <td>*Opóźnienie (dni)</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
                              <td>Stawka</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
                              <td>**Wyliczone odsetki</td>                                                                                                                                                                                                                                                                                                            
                              <td>Kwota</td>                                                                                                                                      
                              <td className="td_right">Kwota przypisania / rozliczenia</td>                                                                                                                                      
                              <td className="td_option"></td>                                                                                  
                       </tr>
                  </thead>
                  <tbody>
                    {
                        tab.roz.map( ( item, ix) => {

                                 var rowStyle = " row ";
                                 if(ix % 2 == 0 )rowStyle = " row2 ";

                                    return  <tr className={rowStyle}> 
                                                <td className="gocenter">{ix+1}</td>                           
                                                <td className="gocenter">
                                                    {item.saldo.data_operacji}                                                                                                    
                                                </td>    
                                                <td>
                                                    {item.saldo.opis} &nbsp;
                                                     {
                                                        item.saldo.fak_faktury_id > 0 &&
                                                        <sup className="link_normal"  v="invoice" id={item.saldo.fak_faktury_id} onClick={changeView} >idź do faktury</sup>
                                                     }
                                                </td>                                                      
                                                <td className="gocenter"> 
                                                    {
                                                        item.ods != undefined &&
                                                        <Fragment>
                                                            {item.ods.ilosc_dni}<br/> {item.ods.termin_platnosci} / {item.ods.data_platnosci}  
                                                        </Fragment>
                                                    }
                                                    {
                                                        item.ods == undefined &&
                                                        <Fragment>
                                                            Nie dotyczy
                                                        </Fragment>
                                                    }
                                                </td>   
                                                <td className="gocenter"> 
                                                    {
                                                        item.ods != undefined &&
                                                        <Fragment>
                                                            {item.ods.stawka}
                                                        </Fragment>
                                                    }
                                                    {
                                                        item.ods == undefined &&
                                                        <Fragment>
                                                           -
                                                        </Fragment>
                                                    }
                                                </td>                                                                                                                                                                                                                                                                                                                                                    
                                                <td className="goright">
                                                    {
                                                        item.ods != undefined &&
                                                        <Fragment>
                                                                {
                                                                    item.blokada == "0" &&
                                                                    <Fragment>
                                                                         <sup className="link_color"  atr-id={item.id} onClick={addTrash}>do koszyka</sup> 
                                                                         &nbsp;
                                                                    </Fragment>
                                                                }                                                               
                                                                <FormatDecimal value={item.ods.kwota_odsetek}/>
                                                        </Fragment>                                                        
                                                    }                                                                                                         
                                                </td>  

                                                <td className="goright"><FormatDecimal value={item.saldo.kwota}/> </td>                                                                                                                                      
                                                <td className="goright"><FormatDecimal value={item.kwota}/></td>                                                                                                                                      
                                                 <MenuTable>
                                                    <ul>
                                                        {
                                                            item.blokada == '0' &&
                                                            <li atr-id={item.id} atr-title={item.saldo.opis + " " + item.kwota}  onClick={goRemove}>Usuń przypisanie</li>
                                                        }
                                                      
                                                    </ul>                                                                                
                                                 </MenuTable>
                                        </tr>
                        } )
                    }

                     <tr className="">   
                              <td> </td>                           
                              <td> </td>                                                                                                                                    
                              <td> </td>                                                                                                                                                                                                                                                                                                            
                              <td> </td>                                                                                                                                                                                                                                                                                                            
                              <td> </td>                                                                                                                                                                                                                                                                                                            
                              <td> </td>                                                                                                                                                                                                                                                                                                            
                              <td> </td>                                                                                                                                      
                              <td className="gobold goright"> <FormatDecimal value={sumKwPrzypisane} /> </td>   
                              <td className=""></td>                                                                                  
                       </tr>

                  </tbody>
           </table>
          
           <div>
               <div>* opóźnienie liczone od następnego dnia po terminie płatności</div>
               <div>** kwota sugerowanych odsetek do noty obciążeniowej</div>
           </div>

 
       

            <div className="form_tab_title">Pozycje możliwe do przypisania ({tab.doroz.length}):</div>

    
                   <table className="table"  >
                  <thead>
                       <tr className="header">                                                                                               
                              <td className="td_left">LP</td>                           
                              <td>Data</td>                                                                                                                                    
                              <td>Opis</td>                                                                                                                                                                                                                                                                                                            
                              <td>Opóźnienie w dniach</td>                                                                                                                                                                                                                                                                                                            
                              <td>Kwota</td>                                                                                                                                      
                              <td >Do wykorzystania</td>                                                                                                                                      
                              <td className="td_right"></td>                                                                                  
                              <td className="td_option"></td>                                                                                  
                       </tr>
                  </thead>
                  <tbody>
                    {
                        tab.doroz.map( ( item, ix) => {

                                 var rowStyle = " row ";
                                 if(ix % 2 == 0 )rowStyle = " row2 ";

                                    return  <tr className={rowStyle}> 
                                                <td className="gocenter">{ix+1}</td>                           
                                                <td className="gocenter">{item.data_operacji}</td>                                                                                                                                    
                                                <td>
                                                    {item.opis} &nbsp;
                                                    {
                                                        item.fak_faktury_id > 0 &&
                                                        <sup className="link_normal"  v="invoice" id={item.fak_faktury_id} onClick={changeView} >idź do faktury</sup>
                                                    }
                                                </td>                                                                                                                                                                                                                                                                                                            
                                                <td className="gocenter"> 
                                                    {
                                                        item.ods != undefined &&
                                                        <Fragment>
                                                            {item.ods.ilosc_dni}
                                                        </Fragment>
                                                    }
                                                    {
                                                        item.ods == undefined &&
                                                        <Fragment>
                                                            Nie dotyczy
                                                        </Fragment>
                                                    }
                                                </td>                                                                                                                                      
                                                <td className="goright"><FormatDecimal value={item.kwota}/> </td>                                                                                                                                      
                                                <td className="goright"><FormatDecimal value={item.pozostalo}/></td>                                                                                                                                      
                                                <td className="td_btn_option goright">
                                                        {
                                                            tab.pozostalo != 0 &&                                                  
                                                            <Fragment>
                                                                <div className="simple_filed">
                                                                    <InputDecimal  value={item.sugerowana} err={null}  valChange={valChangeListener} goNext={null} name={ ix+"@sugerowana"} placeholder={": "} className='  w50 ' req='0' firstUp="0" />                                                                                                                                              
                                                                </div>                                                                
                                                            </Fragment>                                                                                                                                                                                                                                           
                                                        }
                                                </td>
                                                <td className="td_btn_option">
                                                        {
                                                            item.sugerowana == 0 && tab.pozostalo != 0 &&                                                  
                                                            <Fragment>
                                                                <span className="btn" atr-inx={ix} onClick={assignCalc} >Przypisz max. </span>                                                               
                                                            </Fragment>                                                                                                                                                                                                                                           
                                                        }

                                                    {
                                                        item.sugerowana != 0 && 
                                                        <span className="btn" atr-inx={ix} onClick={saveCalc}>zapisz</span>
                                                    }                                                    
                                                </td>
                                        </tr>
                        } )
                    }

                       <tr className="">                                                                                               
                              <td className="td_left">LP</td>                           
                              <td> </td>                                                                                                                                    
                              <td> </td>                                                                                                                                                                                                                                                                                                            
                              <td> </td>                                                                                                                                      
                              <td className="gobold goright" ><FormatDecimal value={sumDoWyk} /></td>                                                                                                                                      
                              <td className="gobold goright" ><FormatDecimal value={sumSugerowana} /></td>                                                                                 
                              <td className="td_option"></td>                                                                                  
                       </tr>

                  </tbody>
           </table>


          {dialog}

    </div>
}



export default CalculateReview;